import e from "../../node_modules/@babel/runtime/helpers/esm/extends.js";
import { __rest as r } from "../../node_modules/tslib/tslib.es6.js";
import s, { forwardRef as t } from "react";
var i = function i(t) {
    var i = t.alt,
      o = void 0 === i ? "" : i,
      a = t.imgRef,
      l = t.shouldLoad,
      d = t.src,
      c = t.srcSet,
      m = r(t, ["alt", "imgRef", "shouldLoad", "src", "srcSet"]);
    return s.createElement("img", e({}, m, {
      alt: o,
      src: l ? d : void 0,
      "data-src": l ? void 0 : d,
      srcSet: l ? c : void 0,
      "data-srcset": l ? void 0 : c,
      ref: a
    }));
  },
  o = t(function (t, o) {
    var a = t.lazy,
      l = void 0 === a || a,
      d = t.media,
      c = t.shouldLoad,
      m = void 0 !== c && c,
      n = t.sizes,
      f = t.src,
      u = t.srcSet,
      p = r(t, ["lazy", "media", "shouldLoad", "sizes", "src", "srcSet"]),
      v = function (e, r) {
        return e.includes(r) ? e : e.replace(/\/filters:(.*?)\/f\//gm, "/filters:$1:" + r + "/f/").replace(/\/(?!filters:)([^/]*)\/f\//gm, "/$1/filters:" + r + "/f/");
      }(u || f, "format(webp)");
    return s.createElement("picture", null, s.createElement("source", {
      srcSet: v,
      sizes: n,
      type: "image/webp",
      media: d
    }), s.createElement(i, e({}, p, {
      src: f,
      srcSet: u,
      sizes: n,
      loading: l ? "lazy" : "eager",
      shouldLoad: m,
      imgRef: o
    })));
  });
export { o as Picture };